import { LeadSourcesSettingsRoute } from "components/manage/lead-sources-settings/lead-sources-settings-route";
import { useOfficeLeadSourcesVisibility } from "components/manage/lead-sources-settings/use-office-lead-sources-visibility";
import { Spinner } from "components/ui/spinner";
import React from "react";
import { Redirect } from "react-router";

export const RegionSettingsLeadSources: React.FC<unknown> = () => {
    const visibility = useOfficeLeadSourcesVisibility();
    switch (visibility) {
        case "loading":
            return <Spinner />;
        case "shown":
            return <LeadSourcesSettingsRoute />;
        case "hidden":
            return <Redirect to="/settings/region/invoices" />;
    }
    const exhaustiveCheck: never = visibility;
    throw new Error(`Unhandled office lead sources visibility: ${exhaustiveCheck}`);
};
